import moment from 'moment-timezone'

const timezone = 'America/Chicago'
export const defaultFormat = 'YYYY-MM-DD HH:mm:ss'

/**
 * Formats a timestamp to the human readable format
 * @param timestamp
 * @param format
 */
export const formatTimestamp = (timestamp: string | undefined, format = defaultFormat): string => {
  const formatted = moment.utc(timestamp).tz(timezone)
  if (formatted.isValid()) {
    return formatted.format(format)
  }
  console.warn('Invalid timestamp', timestamp)
  return ''
}

/**
 * Get the difference in minutes between now and a timestamp
 * @param timestamp
 */
export const getTimeDifferenceInMinutes = (timestamp: string | undefined): number => {
  const now = moment()
  const then = moment.utc(timestamp)
  return now.diff(then, 'minutes')
}

/**
 * Get the difference in hours between now and a timestamp
 * @param timestamp
 */
export const fromNow = (timestamp: string | undefined): string => {
  const then = moment.utc(timestamp).tz(timezone)
  return then.fromNow()
}
